<div *ngIf="dynamicPricingEnabled && showDynamicPricingCTA">
  <sbnb-step-trigger
    headline="Dynamic Pricing"
    subline="With dynamic pricing on, your prices update automatically to match market demand."
    [on]="true"
    (click)="dynamicPricingCTAClicked()"></sbnb-step-trigger>
</div>

<ng-container *ngIf="!dynamicPricingEnabled">
  <div *ngIf="pricingFeeDiscountData$ | async as feeDiscountData" class="@container">
    <div class="flex items-center justify-between gap-3 mb-4">
      <span class="flex items-center gap-2">
        <h3 class="flex-1 !mb-0">Base price</h3>
        <sbnb-icon
          icon="details"
          [size]="16"
          class="text-night-lighter @md:hidden"
          [matTooltip]="basePriceDescription"></sbnb-icon>
      </span>
      <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.basePrice"></sbnb-save-indicator>
    </div>
    <p class="text__small" class="hidden @md:block">
      {{ basePriceDescription }}
    </p>

    <div *ngFor="let base of basePrice" class="flex @md:items-center @md:gap-3 gap-1 mb-2 @md:flex-row flex-col">
      <span class="flex-1 text-sm flex flex-col gap-1">
        <span class="flex items-center justify-between">
          <span class="strong flex-1">{{ base.label }}</span>
          <sbnb-icon-airbnb [size]="12" class="@md:hidden mr-[2px]"></sbnb-icon-airbnb>
        </span>
        <span *ngIf="base.description" class="text-sm text-night hidden @md:block">
          {{ base.description }}
        </span>
      </span>

      <div class="flex flex-col gap-2 @md:items-end">
        <div class="flex gap-3 items-center">
          <sbnb-icon-airbnb [size]="12" class="hidden @md:block"></sbnb-icon-airbnb>
          <mat-form-field class="input__mini w-full nopadding @md:!max-w-[120px]">
            <span matPrefix class="prefix-bg">
              <span class="text__small" style="padding-right: 12px">{{ currency | currencyCode }}</span>
            </span>
            <input
              matInput
              type="number"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [disabled]="dynamicPricingEnabled"
              [(ngModel)]="feeDiscountData[base.key].value"
              (change)="savePriceChange(base.key, feeDiscountData[base.key])" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</ng-container>
